/** Lowercase and strip accents so queries like "Tur" match "Türkiye". */
export function normalizeSearchText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim();
}

export function matchesSearchQuery(
  fields: Array<string | null | undefined>,
  query: string,
): boolean {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;
  return fields.some((field) =>
    normalizeSearchText(String(field ?? "")).includes(normalizedQuery),
  );
}
